// extracted by mini-css-extract-plugin
module.exports = {"container":"drawerFooter_container__3E2ZF"};